<!-- If the phone value is change in js, trigger the load event on the hidden field-->
<!-- js example, :
	<input-tel name="phone" title="Numéro de téléphone" placeholder="Entrez un numéro de téléphone"></input-tel>
-->
<template>
    <div class="form-group">
        <label :for="name">{{ title }}:</label>
        <vue-tel-input :id="'vti-' + name" :name="'vti-' + name" v-model="phone" v-bind="bindProps" @input="handleInput"
              @enter="emitEnter"></vue-tel-input>
        <input hidden="" type="tel" v-model="e164Number" :id="name" :name="name" @load="updateModel($event)" />
        <p class="text-center alert alert-danger" v-if="error">{{error}}</p>
    </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
export default {
  name: 'inputTel',
  props: {
    title: { default: '' },
    placeholder: { default: '' },
    name: { default: '' },
    required: { default: false },
    value: { default: '' }
  },
  components: {
    VueTelInput
  },
  data () {
    return {
      e164Number: this.value,
      phone: this.value,
      bindProps: {
        defaultCountry: 'FR',
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: this.placeholder,
        required: this.required,
        enabledCountryCode: false,
        enabledFlags: true,
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: 'on',
        name: 'vti-' + this.name,
        maxLen: 25,
        wrapperClasses: 'form-control',
        inputClasses: '',
        inputId: 'vti-' + this.name,
        dropdownOptions: { disabledDialCode: false },
        inputOptions: { showDialCode: false }
      },
      error: ''
    }
  },
  mounted () {
    this.$emit('input', this.value === null ? '' : this.value)
  },
  watch: {
    value: function (newVal) {
      this.phone = newVal
      this.e164Number = newVal
    }
  },
  methods: {
    handleInput (e, input) {
      this.error = ''

      if (input.valid) {
        this.e164Number = input.number
        this.$emit('input', this.e164Number)
      } else if (input.number === '' && !this.required) {
        if (this.required) {
          this.error = 'Le numéro de téléphone est obligatoire'
        } else { // Empty but not required return empty
          this.e164Number = ''
          this.$emit('input', '')
        }
      } else {
        this.error = "Le numéro que vous avez entré n'est pas un numéro valide."
      }
    },
    emitEnter (e) {
      this.$emit('enter')
    },
    updateModel (e) { // Update model from the hidden field use for blade form
      console.log($(e.target).val());
      console.log('SANS $', e.target.value);

      this.phone = $(e.target).val()
    }
  }
}
</script>

<style lang="css" scoped>
/* >>> to query element in child component. ex: .componentClass >>> .childClass */
  .vue-tel-input >>> .vti__dropdown-list {
    z-index: 100056 !important;
  }
</style>
